<template>
  <div>
    <el-row :gutter="5">
      <el-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
        <BilletExcelObjectsLine />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import BilletExcelFileDetailCard from './BilletExcelFileDetailCard.vue';
import BilletExcelObjectsPie from './BilletExcelObjectsPie.vue';
import BilletExcelObjectsLine from './BilletExcelObjectsLine.vue';

export default {
  components: { BilletExcelFileDetailCard, BilletExcelObjectsPie, BilletExcelObjectsLine },
  props: ["list"],
  computed: {
    rowsNeed() {
      const lines = this.list ? this.list.length / 4 : 1;
      return Math.ceil(lines);
    },
  },
  methods: {
    row(index, count) {
      return (index * 4) + count;
    }
  },
  data() {
    return {
      started: 0,
    }
  }
}
</script>
